import {DIVE_BRAKE,diveBrakeSpeed} from '../../../shared/src/flightPhysics';

/** One timing contract for the Ctrl-dive controller, landing clip and crystals.
 * `lead` is the anticipation window: long enough for the body to swing from
 * head-down to feet-first at a readable rate while the touchdown flare brakes. */
export const DIVE_LANDING={lock:1,lead:.55,height:45,clipImpact:1.05}as const;

/** Seconds until a dive falling at `down` m/s reaches a floor `clearance` m
 * below, following the controller's brake curve (DIVE_BRAKE) once inside it. */
export function diveTimeToImpact(clearance:number,down:number):number{
  if(!(clearance>0))return 0;
  const speed=Math.max(.5,down),a=DIVE_BRAKE.decel,touchdown=DIVE_BRAKE.touchdown;
  // Height at which the brake curve meets the current speed.
  const knee=speed>touchdown?(speed*speed-touchdown*touchdown)/(2*a):0;
  if(clearance<=knee)return Math.max(0,(Math.min(speed,diveBrakeSpeed(clearance))-touchdown)/a);
  return (clearance-knee)/speed+(speed>touchdown?(speed-touchdown)/a:0);
}

export function diveLandingLead(clearance:number,climb:number):number|null{
  if(!Number.isFinite(clearance)||clearance<0||clearance>DIVE_LANDING.height||climb>=-3)return null;
  const time=diveTimeToImpact(clearance,-climb);
  return time<=DIVE_LANDING.lead?time:null;
}
